<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="pre-wrap"
  >
    <div
      class="back-mobile-btn"
      @click="prevStep"
    >
      <i class="fa fa-arrow-left" />
    </div>
    <h3>
      {{ $t('preCheckIn.signDocuments.title') }}
    </h3>
    <el-form
      :model="signDocuments"
      ref="signDocumentsForm"
      class="sign-documents pre-reg"
      label-position="top"
    >
      <el-row class="block">
        <el-row class="title">
          {{ $t('preCheckIn.signDocuments.formTitle') }}
        </el-row>

        <el-row class="data full">
          <el-form-item
            class="list-docs"
          >
            <li
              v-for="item in documents"
              :key="item.id"
              @click="getPreviewDocument(item.name)"
            >
              {{ item.fullName }}
            </li>
          </el-form-item>
          <el-form-item
            prop="review"
            class="is-reviewed"
          >
            <el-checkbox
              v-model="isDocsReviewed"
            >
              {{ $t('preCheckIn.signDocuments.labels.review') }}
            </el-checkbox>
          </el-form-item>
          <el-form-item
            v-if="completeSignature"
            class="signature-complete"
          >
            <img
              :src="signatureData"
            >
          </el-form-item>
          <el-form-item
            class="sign-btn"
          >
            <el-button
              @click="signAllDocuments"
              type="sign"
              :disabled="!isDocsReviewed"
            >
              {{ $t('common.buttons.signDoc') }}
            </el-button>
          </el-form-item>
          <div
            v-if="document"
            class="document-overlay"
          >
            <div class="document-wrapper">
              <div class="header">
                <span>
                  <el-button
                    :disabled="page <= 1"
                    @click="page--"
                  >
                    ❮
                  </el-button>
                  {{ page }} / {{ pageCount }}
                  <el-button
                    :disabled="page >= pageCount"
                    @click="page++"
                  >
                    ❯
                  </el-button>
                </span>
              </div>
              <div class="content">
                <vue-pdf-embed
                  ref="pdfRef"
                  :page="page"
                  @rendered="handleDocumentRender"
                  :source="pdfSource"
                />
              </div>
            </div>
            <span
              class="close"
              @click="closeDocument"
            />
          </div>
          <div
            v-if="showSignature"
            class="signature-overlay"
          >
            <div class="signature-wrapper">
              <span>{{ $t('preCheckIn.signDocuments.labels.signature') }}</span>
              <signature
                :signature.sync="signature"
              />
            </div>
            <span
              class="close"
              @click="showSignature = !showSignature"
            />
          </div>
        </el-row>
      </el-row>
      <el-form-item
        class="submit-container"
      >
        <el-form-item
          class="submit-buttons"
        >
          <el-button
            @click="prevStep"
            type="back"
          >
            {{ $t('common.buttons.back') }}
          </el-button>
          <el-row
            class="right-btn"
          >
            <el-button
              type="primary"
              @click="submitForm('signDocumentsForm')"
              :disabled="!completeSignature || (completeSignature && !isDocsReviewed)"
            >
              {{ $t('common.buttons.next') }}
            </el-button>
          </el-row>
        </el-form-item>
      </el-form-item>
    </el-form>
  </el-row>
</template>
<script>
import store from "../../store";
import moment from 'moment';
import Signature from '../components/Signature';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  name: 'SignDocuments',
  components: {
    Signature,
    VuePdfEmbed
  },
  data: () => {
    return {
      signDocuments: {},
      document: null,
      userData: {},
      appData: {},
      fullscreenLoading: false,
      patientNumber: null,
      loading: false,
      isLoading: false,
      activeStep: null,
      routerName: 'ThankYou',
      routerSkipName: 'ReferringProvider',
      routerPrevName: 'Questionnaire',
      documents: [],
      isDocsReviewed: false,
      showSignature: false,
      signature: '',
      signatureData: '',
      completeSignature: false,
      findings: [],
      pdfSource: '',
      page: 1,
      pageCount: 1,
      languages: ['en', 'es'],
      locale: 'en'
    };
  },
  created () {
    let pathData = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
    if (this.languages.includes(pathData[0])) this.locale = pathData[0];
    this.fullscreenLoading = true;
    this.setProgressBar();
    this.activeStep = this.$route.path.substring(1).split('/')[1];
    this.patientNumber = store.getters.patientData.patientNumber;
    if (!this.patientNumber) {
      this.getDataByPatientNumber().then(() => {
        this.patientNumber = store.getters.patientData.patientNumber;
        this.setData();
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    } else {
      this.setData();
    }
  },
  watch: {
    signature: function (value) {
      this.showSignature = !this.showSignature
      this.completeSignature = true;
      this.signatureData = value
    },
    'isDocsReviewed': function (val) {
      let newValue = val ? 'true' : 'false';
      this.changeField({isDocsReviewed: newValue});
    },
    'completeSignature': function (val) {
      let newValue = val ? 'true' : 'false';
      this.changeField({completeSignature: newValue});
    },
  },
  methods: {
    handleDocumentRender() {
      this.pageCount = this.$refs.pdfRef.pageCount
    },
    signAllDocuments() {
      this.completeSignature = false;
      this.showSignature = !this.showSignature
    },
    closeDocument() {
      this.$set(this, 'document', null);
    },
    getDataFields(docName) {
      let dataFields = {
        patientNumber: this.userData.patientNumber,
        practiceId: this.appData.appPracticeId,
        documentType: docName,
        serviceCenter: this.appData.clinic.name,
        findings: null,
        localization: this.locale,
        signature: this.signature,
        fields: {
          "##address##": this.appData.clinic.Line1,
          "##city##": this.appData.clinic.City,
          "##state##": this.userData.address.state,
          "##zip##": this.appData.clinic.Zip,
          "##age##": moment().diff(this.userData.dateOfBirth, 'years', false),
          "##sex##": this.userData.sex
        }
      }
      if (docName == 'STOCKING') {
        if (this.$route.params.findingsData) {
          this.findings = this.$route.params.findingsData;
        }
        dataFields.findings = this.findings;
      }
      if (docName == 'COB') {
        let additionalPdfData = {
          insuranceName: this.appData.insuranceName,
          patientName: this.userData.firstName + ' ' + this.userData.lastName,
          patientDob: this.userData.dateOfBirth,
          patientInsuranceId: this.appData.insurance,
          patientGroupNumber: this.appData.groupNumber
        }
        Object.assign(dataFields, {additionalPdfData: additionalPdfData});
      }
      return dataFields;
    },
    getPreviewDocument: function (name) {
      this.fullscreenLoading = true;
      let fields = this.getDataFields(name)
      return this.$axios('Document/GetPatientDocumentToPreview', {
        method: 'POST',
        data: fields,
      }).then((response) => {
        if (response.data) {
          this.document = response.data.data;
          this.page = 1;
          this.$set(this, 'pdfSource', 'data:application/pdf;base64,' + response.data.data)
          this.fullscreenLoading = false;
        }
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.signDocuments.labels.doc') }));
      });
    },
    prevStep(){
      if (!this.$route.params.questionsData) {
        this.goBack(this.routerSkipName, 'signDocuments')
      } else {
        this.goBack(this.routerPrevName, 'signDocuments')
      }
    },
    setData() {
      this.saveStatisticData(this.getSessionId(), {
        active_step: this.activeStep,
        render_SignDocuments : 'true'
      });
      this.userData = store.getters.patientData
      this.updateUserAppData(this.userData.patientId, {
        active_pr_step: this.activeStep,
        active_route: this.$route.name
      });
      this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getUserData',{
        pid: this.userData.patientId
      }).then((response) => {
        if (response.data) {
          this.$set(this, 'appData', response.data.appData);
          this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getServiceCenterData', {
            clinicId: this.appData.parentClinicId
          }).then((response) => {
            if (response.data.isSuccess) {
              this.$set(this.appData, 'clinic', response.data.data);
              this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getInsuranceName', {
                code: this.appData.insurance
              }).then((response) => {
                if (response.data.isSuccess) {
                  this.$set(this.appData, 'insuranceName', response.data.name);
                  this.$axios.get(process.env.VUE_APP_INTERNAL_API + '/api/getPatientAppointments',{ params: {
                    patientId: this.userData.patientId,
                    patientNumber: this.userData.patientNumber
                  }}).then((response) => {
                    if (response.data.isSuccess) {
                      const appointments = response.data.data;
                      let appointment = false;
                      if (Object.keys(appointments).length !== 0) {
                        appointment = response.data.data.find((el) => {
                          return el.appointmentId === this.appData.appointmentId;
                        });
                      }
                      if (appointment) {
                        this.$set(this.appData, 'appPracticeId', appointment.practiceId);
                        this.$axios('Document/GetPatientDocumentsToSign', {
                          method: 'GET',
                          params: {
                            patientNumber: this.userData.patientNumber,
                            practiceId: appointment.practiceId,
                            apptId: this.appData.appointmentId,
                          }
                        }).then((response) => {
                          if (response.data.isSuccess) {
                            if (response.data.data.length !== 0) {
                              response.data.data.forEach((document) => {
                                if (document.isNeedEmployeeSignature || (this.appData.insurance == 'SELF' && document.name == 'COB'))  return;
                                this.documents.push(document);
                              });
                              if (this.$route.params.questionsData || this.appData.patientFindings) {
                                this.$axios('/PatientSurvey/GetQuestionnaire', {
                                  method: 'POST',
                                  data: {
                                    language: this.locale.toUpperCase(),
                                    reasonCode: this.appData.reasonCode,
                                    gender: this.userData.gender,
                                  }
                                }).then((response) => {
                                  if (response.data.isSuccess) {
                                    if (response.data.data) {
                                      let atLeastOneFindingHasYesValue = false,
                                          findings = this.appData.patientFindings;
                                      if (findings.length) {
                                        for (const question of findings) {
                                          if (question.yNResultFlag === 'Y') {
                                            atLeastOneFindingHasYesValue = true;
                                            break;
                                          }
                                        }
                                      }
                                      if (atLeastOneFindingHasYesValue && response.data.data[0].page.questionnaireType == "ConservativeTherapy") {
                                        this.documents.push({
                                          name: 'STOCKING',
                                          fullName: 'Stocking'
                                        });
                                      }
                                      if (this.documents.length == 0) {
                                        this.$router.push({
                                          name: this.routerName,
                                          params: {
                                            patientNumber: this.patientNumber
                                          },
                                        });
                                      }
                                    }
                                  }
                                  this.fullscreenLoading = false;
                                }).catch(() => {
                                  this.fullscreenLoading = false;
                                  this.setMessage(this.$t('common.errors.fail'));
                                });
                              } else {
                                this.fullscreenLoading = false;
                              }
                            } else {
                              this.setMessage(this.$t('common.errors.doc'));
                              this.$router.push({
                                name: this.routerName,
                                params: {
                                  patientNumber: this.patientNumber
                                },
                              });
                            }
                          } else {
                            this.fullscreenLoading = false;
                            this.setMessage(this.$t('common.errors.fail'));
                          }
                        }).catch(() => {
                          this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.signDocuments.labels.list') }));
                          this.fullscreenLoading = false;
                        });
                      } else {
                        this.setMessage(this.$t('common.errors.app'));
                        this.fullscreenLoading = false;
                      }
                    } else {
                      this.fullscreenLoading = false;
                      this.setMessage(this.$t('common.errors.fail'));
                    }
                  }).catch(() => {
                    this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.signDocuments.labels.app') }));
                    this.fullscreenLoading = false;
                  });
                }
              }).catch(() => {
                this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.signDocuments.labels.insurance') }));
                this.fullscreenLoading = false;
              });
            }
          }).catch(() => {
            this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.signDocuments.labels.clinic') }));
            this.fullscreenLoading = false;
          });
        }
      }).catch(() => {
        this.setMessage(this.$t('common.errors.data'));
        this.fullscreenLoading = false;
      });
    },
    submitForm() {
      this.fullscreenLoading = true;
      this.errors = false;
      this.saveStatisticData(this.getSessionId(), {
        submit_SignDocuments: 'true'
      });
      this.documents.forEach((item, key) => {
        let fields = this.getDataFields(item.name);
        let serviceCenterPdfInfos = [{
            practiceId: this.appData.appPracticeId,
            serviceCenterName: this.appData.clinic.name
          }];
        let appointments = [this.appData.appointmentId];
        Object.assign(fields, {serviceCenterPdfInfos: serviceCenterPdfInfos});
        Object.assign(fields, {appointmentsIds: appointments});
        return this.$axios('Document/SavePatientDocument', {
          method: 'POST',
          data: fields,
        }).then((response) => {
          if (response.data) {
            if ((this.documents.length - 1) == key) {
              if (!this.errors) {
                this.updateStepsData(this.userData.patientId, {[this.activeStep] : 1}).then((response) => {
                  if (response.data.isSuccess) {
                    this.$router.push({
                      name: this.routerName,
                      params: {
                        patientNumber: this.patientNumber
                      },
                    });
                  } else {
                    this.fullscreenLoading = false;
                    this.setMessage(this.$t('common.errors.fail'));
                  }
                }).catch(() => {
                  this.fullscreenLoading = false;
                  this.setMessage(this.$t('common.errors.fail'));
                });
              } else {
                this.fullscreenLoading = false;
                this.setMessage(this.$t('common.errors.saveAllDoc'));
              }
            }
          } else {
            this.errors = true;
            this.fullscreenLoading = false;
            this.setMessage(this.$t('common.errors.saveDoc', { type: item.fullName }));
          }
        }).catch(() => {
          this.fullscreenLoading = false;
          this.setMessage(this.$t('common.errors.fail'));
        });
      });
    }
  }
};
</script>
